import type { ComponentType } from 'react';
import { looksLikeWifiQuery } from '../lib/wifiName';
import { KeysByWifiView } from './KeysByWifiView';

export interface PaletteViewProps {
    /** Close the whole palette. */
    close: () => void;
    /** Return to the main palette list. */
    back: () => void;
    /** Text to pre-fill the view's input with, e.g. a Wi-Fi name pasted into the main search. */
    initialQuery: string;
}

interface PaletteViewEntry {
    component: ComponentType<PaletteViewProps>;
    /** When it accepts the raw main-search query, the view's action is offered at the top and opened with that query. */
    matchQuery?: (rawQuery: string) => boolean;
}

/** Client views opened by actions whose descriptor has `view: '<id>'`. */
export const PALETTE_VIEWS: Record<string, PaletteViewEntry> = {
    'keys-by-wifi': { component: KeysByWifiView, matchQuery: looksLikeWifiQuery },
};

export const VIEW_QUERY_MATCHERS = Object.fromEntries(Object.entries(PALETTE_VIEWS).map(([id, v]) => [id, v.matchQuery]));
